import { useState, useEffect, useRef } from 'react';

const CALIFORNIA_CITIES = [
  'Adelanto',
  'Agoura Hills',
  'Alameda',
  'Albany',
  'Alhambra',
  'Aliso Viejo',
  'Alturas',
  'Amador City',
  'American Canyon',
  'Anaheim',
  'Anderson',
  'Angels Camp',
  'Antioch',
  'Apple Valley',
  'Arcadia',
  'Arcata',
  'Arroyo Grande',
  'Artesia',
  'Arvin',
  'Atascadero',
  'Atherton',
  'Atwater',
  'Auburn',
  'Avalon',
  'Avenal',
  'Azusa',
  'Bakersfield',
  'Baldwin Park',
  'Banning',
  'Barstow',
  'Beaumont',
  'Bell',
  'Bell Gardens',
  'Bellflower',
  'Belmont',
  'Belvedere',
  'Benicia',
  'Berkeley',
  'Beverly Hills',
  'Big Bear Lake',
  'Biggs',
  'Bishop',
  'Blue Lake',
  'Blythe',
  'Bradbury',
  'Brawley',
  'Brea',
  'Brentwood',
  'Brisbane',
  'Buellton',
  'Buena Park',
  'Burbank',
  'Burlingame',
  'Calabasas',
  'Calexico',
  'California City',
  'Calimesa',
  'Calipatria',
  'Calistoga',
  'Camarillo',
  'Campbell',
  'Canyon Lake',
  'Capitola',
  'Carlsbad',
  'Carmel-by-the-Sea',
  'Carpinteria',
  'Carson',
  'Cathedral City',
  'Ceres',
  'Cerritos',
  'Chico',
  'Chino',
  'Chino Hills',
  'Chowchilla',
  'Chula Vista',
  'Citrus Heights',
  'Claremont',
  'Clayton',
  'Clearlake',
  'Cloverdale',
  'Clovis',
  'Coachella',
  'Coalinga',
  'Colfax',
  'Colma',
  'Colton',
  'Colusa',
  'Commerce',
  'Compton',
  'Concord',
  'Corcoran',
  'Corning',
  'Corona',
  'Coronado',
  'Corte Madera',
  'Costa Mesa',
  'Cotati',
  'Covina',
  'Crescent City',
  'Cudahy',
  'Culver City',
  'Cupertino',
  'Cypress',
  'Daly City',
  'Dana Point',
  'Danville',
  'Davis',
  'Del Mar',
  'Del Rey Oaks',
  'Delano',
  'Desert Hot Springs',
  'Diamond Bar',
  'Dinuba',
  'Dixon',
  'Dorris',
  'Dos Palos',
  'Downey',
  'Duarte',
  'Dublin',
  'Dunsmuir',
  'East Palo Alto',
  'Eastvale',
  'El Cajon',
  'El Centro',
  'El Cerrito',
  'El Monte',
  'El Segundo',
  'Elk Grove',
  'Emeryville',
  'Encinitas',
  'Escalon',
  'Escondido',
  'Etna',
  'Eureka',
  'Exeter',
  'Fairfax',
  'Fairfield',
  'Farmersville',
  'Ferndale',
  'Fillmore',
  'Firebaugh',
  'Folsom',
  'Fontana',
  'Fort Bragg',
  'Fort Jones',
  'Fortuna',
  'Foster City',
  'Fountain Valley',
  'Fowler',
  'Fremont',
  'Fresno',
  'Fullerton',
  'Galt',
  'Garden Grove',
  'Gardena',
  'Gilroy',
  'Glendale',
  'Glendora',
  'Goleta',
  'Gonzales',
  'Grand Terrace',
  'Grass Valley',
  'Greenfield',
  'Gridley',
  'Grover Beach',
  'Guadalupe',
  'Gustine',
  'Half Moon Bay',
  'Hanford',
  'Hawaiian Gardens',
  'Hawthorne',
  'Hayward',
  'Healdsburg',
  'Hemet',
  'Hercules',
  'Hermosa Beach',
  'Hesperia',
  'Hidden Hills',
  'Highland',
  'Hillsborough',
  'Hollister',
  'Holtville',
  'Hughson',
  'Huntington Beach',
  'Huntington Park',
  'Huron',
  'Imperial',
  'Imperial Beach',
  'Indian Wells',
  'Indio',
  'City of Industry',
  'Inglewood',
  'Ione',
  'Irvine',
  'Irwindale',
  'Isleton',
  'Jackson',
  'Jurupa Valley',
  'Kerman',
  'King City',
  'Kingsburg',
  'La Cañada Flintridge',
  'La Habra',
  'La Habra Heights',
  'La Mesa',
  'La Mirada',
  'La Palma',
  'La Puente',
  'La Quinta',
  'La Verne',
  'Lafayette',
  'Laguna Beach',
  'Laguna Hills',
  'Laguna Niguel',
  'Laguna Woods',
  'Lake Elsinore',
  'Lake Forest',
  'Lakeport',
  'Lakewood',
  'Lancaster',
  'Larkspur',
  'Lathrop',
  'Lawndale',
  'Lemon Grove',
  'Lemoore',
  'Lincoln',
  'Lindsay',
  'Live Oak',
  'Livermore',
  'Livingston',
  'Lodi',
  'Loma Linda',
  'Lomita',
  'Lompoc',
  'Long Beach',
  'Loomis',
  'Los Alamitos',
  'Los Altos',
  'Los Altos Hills',
  'Los Angeles',
  'Los Banos',
  'Los Gatos',
  'Loyalton',
  'Lynwood',
  'Madera',
  'Malibu',
  'Mammoth Lakes',
  'Manhattan Beach',
  'Manteca',
  'Maricopa',
  'Marina',
  'Martinez',
  'Marysville',
  'Maywood',
  'McFarland',
  'Mendota',
  'Menifee',
  'Menlo Park',
  'Merced',
  'Mill Valley',
  'Millbrae',
  'Milpitas',
  'Mission Viejo',
  'Modesto',
  'Monrovia',
  'Montague',
  'Montclair',
  'Monte Sereno',
  'Montebello',
  'Monterey',
  'Monterey Park',
  'Moorpark',
  'Moraga',
  'Moreno Valley',
  'Morgan Hill',
  'Morro Bay',
  'Mount Shasta',
  'Mountain House',
  'Mountain View',
  'Murrieta',
  'Napa',
  'National City',
  'Needles',
  'Nevada City',
  'Newark',
  'Newman',
  'Newport Beach',
  'Norco',
  'Norwalk',
  'Novato',
  'Oakdale',
  'Oakland',
  'Oakley',
  'Oceanside',
  'Ojai',
  'Ontario',
  'Orange',
  'Orange Cove',
  'Orinda',
  'Orland',
  'Oroville',
  'Oxnard',
  'Pacific Grove',
  'Pacifica',
  'Palm Desert',
  'Palm Springs',
  'Palmdale',
  'Palo Alto',
  'Palos Verdes Estates',
  'Paradise',
  'Paramount',
  'Pasadena',
  'Parlier',
  'Paso Robles',
  'Patterson',
  'Perris',
  'Petaluma',
  'Pico Rivera',
  'Piedmont',
  'Pinole',
  'Pismo Beach',
  'Pittsburg',
  'Placentia',
  'Placerville',
  'Pleasant Hill',
  'Pleasanton',
  'Plymouth',
  'Point Arena',
  'Pomona',
  'Port Hueneme',
  'Porterville',
  'Portola',
  'Portola Valley',
  'Poway',
  'Rancho Cordova',
  'Rancho Cucamonga',
  'Rancho Mirage',
  'Rancho Palos Verdes',
  'Rancho Santa Margarita',
  'Red Bluff',
  'Redding',
  'Redlands',
  'Redondo Beach',
  'Redwood City',
  'Reedley',
  'Rialto',
  'Richmond',
  'Ridgecrest',
  'Rio Dell',
  'Rio Vista',
  'Ripon',
  'Riverbank',
  'Riverside',
  'Rocklin',
  'Rohnert Park',
  'Rolling Hills',
  'Rolling Hills Estates',
  'Rosemead',
  'Roseville',
  'Ross',
  'Sacramento',
  'St. Helena',
  'Salinas',
  'San Anselmo',
  'San Bernardino',
  'San Bruno',
  'San Carlos',
  'San Clemente',
  'San Diego',
  'San Dimas',
  'San Fernando',
  'San Francisco',
  'San Gabriel',
  'San Jacinto',
  'San Joaquin',
  'San Jose',
  'San Juan Bautista',
  'San Juan Capistrano',
  'San Leandro',
  'San Luis Obispo',
  'San Marcos',
  'San Marino',
  'San Mateo',
  'San Pablo',
  'San Rafael',
  'San Ramon',
  'Sand City',
  'Sanger',
  'Santa Ana',
  'Santa Barbara',
  'Santa Clara',
  'Santa Clarita',
  'Santa Cruz',
  'Santa Fe Springs',
  'Santa Maria',
  'Santa Monica',
  'Santa Paula',
  'Santa Rosa',
  'Santee',
  'Saratoga',
  'Sausalito',
  'Scotts Valley',
  'Seal Beach',
  'Seaside',
  'Sebastopol',
  'Selma',
  'Shafter',
  'Shasta Lake',
  'Sierra Madre',
  'Signal Hill',
  'Simi Valley',
  'Solana Beach',
  'Soledad',
  'Solvang',
  'Sonoma',
  'Sonora',
  'South El Monte',
  'South Gate',
  'South Lake Tahoe',
  'South Pasadena',
  'South San Francisco',
  'Stanton',
  'Stockton',
  'Suisun City',
  'Sunnyvale',
  'Susanville',
  'Sutter Creek',
  'Taft',
  'Tehachapi',
  'Tehama',
  'Temecula',
  'Temple City',
  'Thousand Oaks',
  'Tiburon',
  'Torrance',
  'Tracy',
  'Trinidad',
  'Truckee',
  'Tulare',
  'Tulelake',
  'Turlock',
  'Tustin',
  'Twentynine Palms',
  'Ukiah',
  'Union City',
  'Upland',
  'Vacaville',
  'Vallejo',
  'Ventura',
  'Vernon',
  'Victorville',
  'Villa Park',
  'Visalia',
  'Vista',
  'Walnut',
  'Walnut Creek',
  'Wasco',
  'Waterford',
  'Watsonville',
  'Weed',
  'West Covina',
  'West Hollywood',
  'West Sacramento',
  'Westlake Village',
  'Westminster',
  'Westmorland',
  'Wheatland',
  'Whittier',
  'Wildomar',
  'Williams',
  'Willits',
  'Willows',
  'Windsor',
  'Winters',
  'Woodlake',
  'Woodland',
  'Woodside',
  'Yorba Linda',
  'Yountville',
  'Yreka',
  'Yuba City',
  'Yucaipa',
  'Yucca Valley',
];

const LocationAutocomplete = ({
  value,
  onChange,
  placeholder = 'Enter city...',
  className = '',
  id,
  name,
  required = false,
  label,
  isRequired = false,
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);

  useEffect(() => {
    if (value) {
      const filtered = CALIFORNIA_CITIES.filter((city) =>
        city.toLowerCase().includes(value.toLowerCase())
      ).slice(0, 10); // Limit to 10 suggestions
      setFilteredSuggestions(filtered);
    } else {
      setFilteredSuggestions([]);
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target) &&
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
        setActiveSuggestion(-1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onChange(e);
    setShowSuggestions(true);
    setActiveSuggestion(-1);
  };

  const handleSuggestionClick = (suggestion) => {
    const event = {
      target: {
        name,
        value: suggestion,
      },
    };
    onChange(event);
    setShowSuggestions(false);
    setActiveSuggestion(-1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (activeSuggestion < filteredSuggestions.length - 1) {
        setActiveSuggestion(activeSuggestion + 1);
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (activeSuggestion > 0) {
        setActiveSuggestion(activeSuggestion - 1);
      }
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeSuggestion >= 0 && filteredSuggestions[activeSuggestion]) {
        handleSuggestionClick(filteredSuggestions[activeSuggestion]);
      }
    } else if (e.key === 'Escape') {
      setShowSuggestions(false);
      setActiveSuggestion(-1);
    }
  };

  const handleFocus = () => {
    if (filteredSuggestions.length > 0) {
      setShowSuggestions(true);
    }
  };

  return (
    <div className="relative">
      {label && (
        <label className="block font-semibold" htmlFor={id}>
          {label}
          {(required || isRequired) && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        ref={inputRef}
        type="text"
        id={id}
        name={name}
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        placeholder={placeholder}
        className={`w-full p-2 border border-gray-300 rounded-md ${className}`}
        required={required || isRequired}
        autoComplete="off"
      />
      {showSuggestions && filteredSuggestions.length > 0 && (
        <div
          ref={suggestionsRef}
          className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto"
        >
          {filteredSuggestions.map((suggestion, index) => (
            <div
              key={suggestion}
              className={`px-3 py-2 cursor-pointer ${
                index === activeSuggestion ? 'bg-blue-100 text-blue-900' : 'hover:bg-gray-100'
              }`}
              onClick={() => handleSuggestionClick(suggestion)}
              onMouseEnter={() => setActiveSuggestion(index)}
            >
              {suggestion}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export { LocationAutocomplete };
